import { WebEntity, WebEntityName } from './types';
import { AdminStudies, UnifiedStudy } from '../types';
import UserEntity from './UserEntity';
import UserTypeEntity from './UserTypeEntity';
import StudiesEntity from './StudiesEntity';
import AdminStudiesEntity from './AdminStudiesEntity';
import UserOccupationEntity from './UserOccupationEntity';

const MyStudiesEntity: WebEntity<UnifiedStudy> = {
  ...StudiesEntity,
  name: 'myStudies' as WebEntityName
};

const OtherStudiesEntity: WebEntity<UnifiedStudy> = {
  ...StudiesEntity,
  name: 'otherStudies' as WebEntityName,
  endpoint: 'estudios/otherStudies'
};

const StudiesInProgressEntity: WebEntity<AdminStudies> = {
  ...AdminStudiesEntity,
  name: 'studiesInProgress' as WebEntityName
};

const StudiesCompletedEntity: WebEntity<AdminStudies> = {
  ...AdminStudiesEntity,
  name: 'studiesCompleted' as WebEntityName
};

export {
  UserEntity,
  UserTypeEntity,
  MyStudiesEntity,
  OtherStudiesEntity,
  StudiesInProgressEntity,
  StudiesCompletedEntity,
  UserOccupationEntity
};
